import React from 'react';
import { useAuth } from '../hooks/useAuth';

const ProfilePage: React.FC = () => {
  const { user } = useAuth();

  return (
    <div>
      <div className="page-heading">
        <div>
          <h1>Profile</h1>
          <p>Your technician login and mapped technician IDs.</p>
        </div>
      </div>

      <div className="content-card profile-card">
        <div className="avatar large">{user?.name?.charAt(0)?.toUpperCase() || 'T'}</div>
        <div className="profile-details">
          <div><span>Name</span><strong>{user?.name}</strong></div>
          <div><span>Mobile</span><strong>{user?.mobile}</strong></div>
          <div><span>Email</span><strong>{user?.email || '-'}</strong></div>
          <div><span>Roles</span><strong>{user?.roles?.join(', ') || '-'}</strong></div>
          <div><span>Technician IDs</span><strong>{user?.technicianIds?.join(', ') || '-'}</strong></div>
        </div>
      </div>
    </div>
  );
};

export default ProfilePage;
